import { addToGlobalThisRet } from "@plugins";

function initAsideAnchorsToggler() {
    const toggler = document.querySelector(".js-active-status-toggler");

    if (toggler) {
        Array.from(toggler.children).forEach((item) => {
            item.addEventListener("click", () => {
                Array.from(toggler.children).forEach((item) => {
                    if (item.classList.contains("active")) {
                        item.classList.remove("active");
                    }
                });

                item.classList.add("active");
            });
        });
    }
}

window.addEventListener("load", () => {
    initAsideAnchorsToggler();
});

addToGlobalThisRet(initAsideAnchorsToggler, "initAsideAnchorsToggler");
